import { createAction } from '@reduxjs/toolkit';
import { listsSlice } from './reducer';

export const { receiveNormalizedLists, addNewList, setUpdatedList, deleteList } = listsSlice.actions;
export const fetchLists = createAction('lists/fetchLists');
export const addList = createAction('lists/addList');
export const editList = createAction('lists/editList');
export const deleteListRequest = createAction('lists/deleteListRequest');
export const setCurrentListAndFetchLists = createAction('lists/setCurrentListAndFetchLists');
